export const texts = {
    label: {
        loading: 'Bitte warten'
    }
};

//# sourceMappingURL=BoxCTA.texts.js.map